import { render, staticRenderFns } from "./reassur.vue?vue&type=template&id=06ee1fbe"
import script from "./reassur.vue?vue&type=script&lang=js"
export * from "./reassur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports